/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type BookingSagasGetEditingInvoicePositionQueryVariables = {
    invoicePositionId: number;
};
export type BookingSagasGetEditingInvoicePositionQueryResponse = {
    readonly invoicePosition: {
        readonly invoicePositionId: string;
        readonly position: number;
        readonly rate: string | null;
        readonly group: string | null;
        readonly description: string | null;
        readonly amount: number | null;
        readonly netSinglePrice: number | null;
        readonly grossPrice: number | null;
        readonly discount: number | null;
        readonly netTotalPrice: number | null;
        readonly includedDistance: number | null;
        readonly bookingId: string | null;
    } | null;
};
export type BookingSagasGetEditingInvoicePositionQuery = {
    readonly response: BookingSagasGetEditingInvoicePositionQueryResponse;
    readonly variables: BookingSagasGetEditingInvoicePositionQueryVariables;
};



/*
query BookingSagasGetEditingInvoicePositionQuery(
  $invoicePositionId: Int!
) {
  invoicePosition(invoicePositionId: $invoicePositionId) {
    invoicePositionId
    position
    rate
    group
    description
    amount
    netSinglePrice
    grossPrice
    discount
    netTotalPrice
    includedDistance
    bookingId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "invoicePositionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "invoicePositionId",
        "variableName": "invoicePositionId"
      }
    ],
    "concreteType": "InvoicePosition",
    "kind": "LinkedField",
    "name": "invoicePosition",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "invoicePositionId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "position",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "group",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "netSinglePrice",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "grossPrice",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "netTotalPrice",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "includedDistance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bookingId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookingSagasGetEditingInvoicePositionQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookingSagasGetEditingInvoicePositionQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "18589bf75582161fe635cf920b0c4e27",
    "id": null,
    "metadata": {},
    "name": "BookingSagasGetEditingInvoicePositionQuery",
    "operationKind": "query",
    "text": "query BookingSagasGetEditingInvoicePositionQuery(\n  $invoicePositionId: Int!\n) {\n  invoicePosition(invoicePositionId: $invoicePositionId) {\n    invoicePositionId\n    position\n    rate\n    group\n    description\n    amount\n    netSinglePrice\n    grossPrice\n    discount\n    netTotalPrice\n    includedDistance\n    bookingId\n  }\n}\n"
  }
};
})();
(node as any).hash = '9d4aa36db4a9c8ae0f77053673c7c3f3';
export default node;
